import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useMedia } from 'react-use';
import { Typography, Icon, LazyLoadImage, LazyLoadSource, FlipTimer } from 'ck-ui';
import { parseSqlDate } from 'ck-utils/dateTime';
import { TermsAndPrivacyLinks } from '../TermsAndPrivacyLinks';
import { SignUpForm } from './SignUpForm';
import styles from './PopupSignup.module.scss';

const SignUpPage = ({
  desktopImage,
  mobileImage,
  mobileImageRatio,
  desktopImageRatio,
  countdownStartTime,
  countdownEndTime,
  countdownText,
  successMessage,
}) => {
  const isMobile = useMedia('(max-width: 1087px)');
  const [hasSignedUp, setHasSignedUp] = useState(false);
  const handleSignedUp = () => setHasSignedUp(true);
  // Timer
  const currentTime = new Date();
  const startTime = parseSqlDate(countdownStartTime, 'AU');
  const endTime = parseSqlDate(countdownEndTime, 'AU');
  const countdownActive = startTime <= currentTime && startTime < endTime && endTime > currentTime;

  return (
    <>
      <div style={{ position: 'relative', paddingBottom: `calc(${isMobile ? mobileImageRatio : desktopImageRatio})` }}>
        <picture>
          <LazyLoadSource media="(max-width: 1087px)" srcSet={mobileImage} />
          <LazyLoadSource media="(min-width: 1088px)" srcSet={desktopImage} />
          <LazyLoadImage
            className={styles.img}
            src={desktopImage}
            alt="SMS Sign up Banner"
          />
        </picture>
      </div>
      <div className={isMobile ? 'mt-4' : 'is-half-width mt-4'} style={{ margin: '0 auto' }}>
        {countdownActive && (
          <div className="has-text-centered">
            <div className="is-flex-centered">
              <div className="has-background-warning">
                <FlipTimer endTime={countdownEndTime} backgroundColor="#ffffff" className="is-flex-centered" />
              </div>
            </div>
            {isMobile && <br />}
            <Typography className="mt-2" display="block" variant="heading9" uppercase>{countdownText}</Typography>
          </div>
        )}
        {hasSignedUp ? (
          <>
            <Typography variant="heading5" align="centered" uppercase className={styles.largeMarginTop}>THANK YOU FOR SIGNING UP!</Typography>
            <Typography
              className={classnames(
                'is-flex',
                'is-flex-centered',
                styles.largeMarginTop,
                styles.tick
              )}
            >
              <Icon color="secondary" name="check" />
            </Typography>
            <Typography
              variant="heading7"
              align="centered"
              uppercase
              className={classnames(styles.largeMarginTop, styles.largeMarginBottom, styles.successMessage)}
              dangerouslySetInnerHTML={{ __html: successMessage }}
            />
          </>
        ) : (
          <SignUpForm
            source="signup_page"
            onSubmitSuccess={handleSignedUp}
          />
        )}
        <TermsAndPrivacyLinks />
      </div>
    </>
  );
};

SignUpPage.propTypes = {
  desktopImage: PropTypes.string.isRequired,
  mobileImage: PropTypes.string.isRequired,
  mobileImageRatio: PropTypes.string.isRequired,
  desktopImageRatio: PropTypes.string.isRequired,
  countdownStartTime: PropTypes.string,
  countdownEndTime: PropTypes.string,
  countdownText: PropTypes.string,
  successMessage: PropTypes.string,
};

SignUpPage.defaultProps = {
  countdownStartTime: null,
  countdownEndTime: null,
  countdownText: null,
  successMessage: null,
};

export { SignUpPage };
